import {
  FULFILLMENT_METHOD_DELIVERY,
  FULFILLMENT_METHOD_COLLECTION,
  FULFILLMENT_TYPE_DELIVERY,
  FULFILLMENT_TYPE_COLLECTION,
  FULFILLMENT_TYPE_MARKETPLACE,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_COLLECTION,
  ORDER_TYPE_MARKETPLACE,
  ORDER_TYPE_DEFAULT,
} from './constants';

export default class OrderType {
  static fromFulfillmentMethod(fulfillmentMethod) {
    const orderTypeMap = {
      [FULFILLMENT_METHOD_COLLECTION]: ORDER_TYPE_COLLECTION,
      [FULFILLMENT_METHOD_DELIVERY]: ORDER_TYPE_DELIVERY,
    };
    return orderTypeMap[fulfillmentMethod] || ORDER_TYPE_DEFAULT;
  }

  static fromFulfillmentType(fulfillmentType) {
    const orderTypeMap = {
      [FULFILLMENT_TYPE_DELIVERY]: ORDER_TYPE_DELIVERY,
      [FULFILLMENT_TYPE_COLLECTION]: ORDER_TYPE_COLLECTION,
      [FULFILLMENT_TYPE_MARKETPLACE]: ORDER_TYPE_MARKETPLACE,
    };
    return orderTypeMap[fulfillmentType] || ORDER_TYPE_DEFAULT;
  }
}
